<template>
  <section class="orders">
    <div class="order-container">
      <van-list
        v-model="loading"
        :finished="finished"
        v-if="list.length != 0"
      >
        <li  v-for='(item,index) in list' :key='index'>
          <order-com :radio="false" :model='item' :type='2' @contect='contect'/>
        </li>
        <div class="bottomShare">
          <div>扫码~定制你的专属周边~</div>
          <img src="/images/base/share_ewm.png" alt="">
        </div>
  
        
      </van-list>
      <div v-else>
        <img src='/images/order/noOrder.png' class='no-list'>
      </div>
    </div>
  </section>
</template>

<script>
  import orderApi from '@/axios/order'
  import zhugeObj from '@/assets/js/track';
  export default {
    name: 'waitConfirmOrders',
    data () {
      return {
        finished : false,
        loading: true,
        list : []
      }
    },
    created () {
      this.getGoodsList();
    },
    mounted () {
      zhugeObj.track({
        title : '订单养护中-曝光',
      })
    },
    methods: {
      contect(){
        this.$emit('contect');
      },
      getGoodsList(){
        let params = {
          state : 20
        };
        orderApi.maintaining(params).then((res)=>{
          this.loading = false;
          this.finished = true;
          this.list = res;
         
        })
      }
    }
  }
</script>

<style scoped lang="scss">
.bottomShare{
  width: 690px;
  padding-top: 20px;
  text-align: center;
  font-size: 26px;
  img{
    width: 150px;
    height: 150px;
    display: block;
    margin: 20px auto 0;
  }
}
  .no-list{
    width:100%;
    margin-top: 300px;
  }
  .orders{
    // position: absolute;
    // height: 100%;
    // width: 100%;
    // top: 0;
    // left: 0;
    
    .order-container{
      // position: absolute;
      // top: 0;
      left: 0;
      // bottom: 108px;
      width: 100%;
      display: flex;
      justify-content: center;
      padding-bottom: 200px;
      // padding-top:100px;
      .van-list{
        width: 690px;
        li{
          width:690px;
          background:rgba(255,255,255,1);
          box-shadow:0px 2px 20px 0px rgba(0,0,0,0.1);
          border-radius:6px;
          margin-top: 30px;
        }
      }
    }
  }
</style>
